import React from 'react'
import useFetch from '../hooks/useFetch'
import { Link, useParams, useHistory } from 'react-router-dom'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { useMsal } from "@azure/msal-react";
import project_task from '../assets/project_task.svg'
import arrow_project from '../assets/arrow_project.svg'
import home_task from '../assets/home_task.svg'
import PREVIOUS from '../assets/PREVIOUS.svg'
import TaskCard from '../components/TaskCard';
import './taskPage.css'

export default function TaskPage() {
  const { instance, accounts } = useMsal();
  const name = accounts[0].name;
  const history = useHistory();
  const email = accounts[0].username;
  const { id } = useParams()
  // const { projectName } = location.state
  const { loading, error, data } = useFetch('/api-dev/expenses/GetProject/' + id, name, email)
  const handleClick = (id) => {
    history.push({
      pathname: '/category/' + id,
    })
  }

  if (loading) return <div className='spinner'>
  <Box sx={{ display: 'flex' }} style={{margin:'40px',justifyContent:'center'}}>
    <CircularProgress />
  </Box> 
</div>;
  if (error) return <p>Error :(</p>
  const {values, tasks, info} = data
  return (
    <div className='page-layout' >
      <div className='navigation-task'>
        <Link to="/" className='link-navigation'>
          <p>
            <img src={home_task} alt="home" className="home" />
            &nbsp;
            <span className='home-task' >Projects</span>
            &nbsp; &nbsp;
          </p>
        </Link>
        <p>
          <img src={arrow_project} alt="home" className="home" />
          &nbsp; &nbsp;
          <span className='project-task' >{info ? info.ProjectName : "No Tasks for this Project"}</span>
        </p>
      </div>
      <div className="project-container-task">
        <div className='project-name-task' >
          <img src={project_task} alt="project" />
          &nbsp; &nbsp;
        {info ? info.ProjectName : "No Tasks for this Project"}
        </div>
        <div className='back-arrow-task'>
        <Link to="/">
          <img src={PREVIOUS} alt="PREVIOUS" className="PREVIOUS" />
          </Link>
        </div>
      </div>
      
      <div className='card-collection' >
         {tasks.filter(task => task.TaskID !== 0).map((task,index) =>(
        <div key={task.TaskID} >
          <TaskCard task={task} index={index} values={values.filter((element)=>element.TaskID === task.TaskID)[0]} handleClick={handleClick} />
        </div>
      ))}
      </div>
    </div>
  )
}
